import { ReactComponent as ArrowRight } from 'assets/icons/icon-arrow-right.svg';

export default ArrowRight;
